import * as React from 'react'
import { View, TouchableOpacity, Text } from 'react-native'
import Tabs from '@components/tabs/Tabs'
import styled from '@theme/styled-components'

import useBreakpoint from '@utils/useBreakpoints'

export interface Option {
  indicator?: number
  label: string
  value: any
}

interface Props {
  data: Option[]
  onItemSelected: (opt: Option) => void
  value?: Option
  phoneMode?: boolean
  disabled?: boolean
}

const SegmentedControl = ({ data, onItemSelected, value, phoneMode, disabled }: Props) => {
  const [, currentBreakpoint] = useBreakpoint()
  const isPhone = phoneMode ? true : currentBreakpoint === 'phone'

  if (!isPhone) {
    return <Tabs disabled={disabled} data={data} onItemSelected={onItemSelected} value={value} isBig />
  }

  return (
    <Container>
      {data.map((d) => {
        const selected = !!value && value.value === d.value
        return (
          <Tab
            disabled={disabled}
            key={d.value}
            selected={selected}
            activeOpacity={0.9}
            onPress={() => onItemSelected(d)}>
            <TabText selected={selected} numberOfLines={1} ellipsizeMode="tail">
              {d.label}
            </TabText>
            {d.indicator !== undefined && (
              <Indicator selected={selected}>
                <IndicatorValue>{d.indicator}</IndicatorValue>
              </Indicator>
            )}
          </Tab>
        )
      })}
    </Container>
  )
}

export default SegmentedControl

const Container = styled(View)`
  flex-direction: row;
  background-color: ${(props) => props.theme.colors.background};
  border-radius: 9px;
  padding: 2px;
  ${(props) => props.theme.constants.shadow};
`
const Tab = styled(TouchableOpacity)<{ selected: boolean }>`
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: ${(props) => (props.selected ? props.theme.colors.segmentedActive : props.theme.colors.background)};
  z-index: ${(props) => (props.selected ? 1 : -1)};
  ${(props) => props.selected && props.theme.constants.shadow};
`
const TabText = styled(Text)<{ selected: boolean }>`
  ${(props) => props.theme.fonts.Subheadline};
  color: ${(props) => (props.selected ? props.theme.colors.primaryText : props.theme.colors.secondaryText)};
  padding: 4px 8px;
`
const Indicator = styled(View)<{ selected: boolean }>`
  min-height: 12px;
  min-width: 12px;
  border-radius: 20px;
  background-color: ${(props) => (props.selected ? props.theme.colors.primary : props.theme.colors.primaryText)};
  justify-content: center;
  align-items: center;
  padding: 0 2px;
`
const IndicatorValue = styled(Text)`
  text-align: center;
  ${(props) => props.theme.fonts.Caption2};
  font-size: 9px;
  color: ${(props) => props.theme.colors.background};
  line-height: 12px;
`
